import createIcon from '../../createIcon';

/**
 * @component @name Bathtub
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyA5QzguMTA0NTcgOSA5IDguMTA0NTcgOSA3QzkgNS44OTU0MyA4LjEwNDU3IDUgNyA1QzUuODk1NDMgNSA1IDUuODk1NDMgNSA3QzUgOC4xMDQ1NyA1Ljg5NTQzIDkgNyA5WiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTIwIDEzVjQuODNDMjAgMy4yNyAxOC43MyAyIDE3LjE3IDJDMTYuNDIgMiAxNS43IDIuMyAxNS4xNyAyLjgzTDEzLjkyIDQuMDhDMTMuNzYgNC4wMyAxMy41OSA0IDEzLjQxIDRDMTMuMDEgNCAxMi42NCA0LjEyIDEyLjMzIDQuMzJMMTUuMDkgNy4wOEMxNS4yOSA2Ljc3IDE1LjQxIDYuNCAxNS40MSA2QzE1LjQxIDUuODIgMTUuMzggNS42NiAxNS4zNCA1LjQ5TDE2LjU5IDQuMjRDMTYuNzQgNC4wOSAxNi45NSA0IDE3LjE3IDRDMTcuNjMgNCAxOCA0LjM3IDE4IDQuODNWMTNIMTEuMTVDMTAuODUgMTIuNzkgMTAuNTggMTIuNTUgMTAuMzMgMTIuMjhMOC45MyAxMC43M0M4Ljc0IDEwLjUyIDguNSAxMC4zNSA4LjI0IDEwLjIzQzcuOTMgMTAuMDggNy41OSAxMCA3LjI0IDEwQzYgMTAuMDEgNSAxMS4wMSA1IDEyLjI1VjEzSDJWMTlDMiAyMC4xIDIuOSAyMSA0IDIxQzQgMjEuNTUgNC40NSAyMiA1IDIySDE5QzE5LjU1IDIyIDIwIDIxLjU1IDIwIDIxQzIxLjEgMjEgMjIgMjAuMSAyMiAxOVYxM0gyMFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Bathtub = createIcon('Bathtub', [
  [
    'path',
    {
      d: 'M7 9C8.10457 9 9 8.10457 9 7C9 5.89543 8.10457 5 7 5C5.89543 5 5 5.89543 5 7C5 8.10457 5.89543 9 7 9Z',
      key: 'vpvji5',
    },
  ],
  [
    'path',
    {
      d: 'M20 13V4.83C20 3.27 18.73 2 17.17 2C16.42 2 15.7 2.3 15.17 2.83L13.92 4.08C13.76 4.03 13.59 4 13.41 4C13.01 4 12.64 4.12 12.33 4.32L15.09 7.08C15.29 6.77 15.41 6.4 15.41 6C15.41 5.82 15.38 5.66 15.34 5.49L16.59 4.24C16.74 4.09 16.95 4 17.17 4C17.63 4 18 4.37 18 4.83V13H11.15C10.85 12.79 10.58 12.55 10.33 12.28L8.93 10.73C8.74 10.52 8.5 10.35 8.24 10.23C7.93 10.08 7.59 10 7.24 10C6 10.01 5 11.01 5 12.25V13H2V19C2 20.1 2.9 21 4 21C4 21.55 4.45 22 5 22H19C19.55 22 20 21.55 20 21C21.1 21 22 20.1 22 19V13H20Z',
      key: '2rojwd',
    },
  ],
]);

export default Bathtub;
